module.exports = __webpack_public_path__ + "img/no-order.51419b17.png";